/**
 * Asynchronously loads the component for ReleasePage
 */

import { lazyLoad } from 'utils/loadable';

export const AcceptanceCriteria = lazyLoad(
  () => import('./index'),
  module => {
    return module.AcceptanceCriteria;
  },
);
